import type { MetaChannelKind } from '@goyone/shared';

/**
 * شعارات قنوات ميتا بألوانها.
 *
 * أيقونات النظام خطّيّة أحاديّة اللون، وهذه شعاراتٌ مموّهة بألوان علاماتها —
 * واتساب أخضر، ماسنجر أزرق، إنستجرام متدرّج — ليعرفها المستخدم فورًا كما في
 * ميتا. مبسَّطةٌ لا منسوخةٌ بالحرف: تكفي للتمييز.
 */
export function ChannelLogo({ kind, size = 20 }: { kind: MetaChannelKind; size?: number }) {
  const s = { width: size, height: size, display: 'block', flex: 'none' } as const;

  if (kind === 'WHATSAPP') {
    return (
      <svg viewBox="0 0 32 32" style={s} aria-hidden="true">
        <path
          fill="#25D366"
          d="M16 3C9.4 3 4 8.4 4 15c0 2.2.6 4.3 1.7 6.1L4 28l7.1-1.7c1.7.9 3.6 1.4 5.6 1.3 6.6 0 12-5.4 12-12S22.6 3 16 3z"
        />
        <path
          fill="#fff"
          d="M12.6 9.6c-.2-.5-.5-.5-.7-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.3 2.4 3.7 5.8 5.1 2.9 1.2 3.5 1 4.1.9.6-.1 2-.8 2.2-1.6.3-.8.3-1.4.2-1.6-.1-.1-.3-.2-.6-.4l-2-1c-.3-.1-.5-.2-.7.1l-.9 1.1c-.2.2-.3.2-.6.1s-1.3-.5-2.4-1.5c-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-1-2.6z"
        />
      </svg>
    );
  }

  if (kind === 'MESSENGER') {
    return (
      <svg viewBox="0 0 32 32" style={s} aria-hidden="true">
        <defs>
          <linearGradient id="msgrGrad" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0" stopColor="#0099FF" />
            <stop offset="0.6" stopColor="#A033FF" />
            <stop offset="1" stopColor="#FF5280" />
          </linearGradient>
        </defs>
        <path
          fill="url(#msgrGrad)"
          d="M16 3C8.6 3 3 8.4 3 15.1c0 3.7 1.7 7 4.5 9.2V29l4.1-2.3c1.4.4 2.8.6 4.4.6 7.4 0 13-5.4 13-12.2S23.4 3 16 3z"
        />
        <path
          fill="#fff"
          d="m8.4 19.1 4.9-5.2 2.5 2.7 4.3-2.7-4.8 5.2-2.5-2.6-4.4 2.6z"
        />
      </svg>
    );
  }

  // إنستجرام
  return (
    <svg viewBox="0 0 32 32" style={s} aria-hidden="true">
      <defs>
        <linearGradient id="igGrad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#FEDA75" />
          <stop offset="0.3" stopColor="#FA7E1E" />
          <stop offset="0.6" stopColor="#D62976" />
          <stop offset="1" stopColor="#4F5BD5" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="26" height="26" rx="8" fill="url(#igGrad)" />
      <circle cx="16" cy="16" r="6" fill="none" stroke="#fff" strokeWidth="2.2" />
      <circle cx="23" cy="9" r="1.5" fill="#fff" />
    </svg>
  );
}
